import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'underscore';
import validator from 'validator';

// NOTE THIS FILE HAS MANY DISPLAY NAME VIOLATIONS
// AND ALL ARE DISABLED BY THE COMMENT BELOW.
/* eslint-disable react/display-name */

var FormMixin = {
  /**
   * Gets a basic input change handler that sets the new value in state
   *
   * @param name
   * @returns {Function}
   */
  getBasicInputChangeHandler: function (name) {
    var self = this;

    return function (e) {
      var obj = {};
      obj[name] = e.target.value;
      self.setState(obj);
    };
  },

  getSelectInputChangeHandler: function (name) {
    var self = this;

    return function () {
      var mutation = {};
      mutation[name] = self.getSelectInputValue(name);
      self.setState(mutation);
    };
  },

  getSelectInputValue: function (name) {
    var ref = name.concat('Input');
    var selectNode = this.refs[ref].getDOMNode();
    return selectNode.options[selectNode.selectedIndex].value;
  },

  /**
   * ### getInputNode()
   *
   * @param {String }name
   * @param {?} type can be a type (usually "text" or "password") or an attribs object w/ type and className properties
   * @returns {XML}
   */
  getInputNode: function (name, type, placeholder) {
    type = type || 'text';

    var attributes = {
      name: name,
      className: 'form-control',
      ref: name + 'Input',
      value: this.state[name],
      onChange: this.getBasicInputChangeHandler(name),
      type: typeof type == 'object' ? 'text' : type,
      placeholder: typeof placeholder == null ? '' : placeholder, // eslint-disable-line valid-typeof
    };

    if (_.isObject(type)) {
      _.extend(attributes, type);
    }

    return React.createElement('input', attributes);
  },

  getTextareaNode: function (name, attributes) {
    attributes = attributes || {};

    attributes = _.defaults(attributes, {
      name: name,
      className: 'form-control',
      ref: name + 'Input',
      value: this.state[name],
      onChange: this.getBasicInputChangeHandler(name),
    });

    return React.createElement('textarea', attributes);
  },

  getSelectNode: function (inputDef) {
    var options = inputDef.options,
      name = inputDef.name,
      attributes = inputDef.attributes || {};

    if (Array.isArray(options)) {
      var newOpts = {};
      options.forEach(function (opt) {
        newOpts[opt] = opt;
      });
      options = newOpts;
    }

    var optionNodes = [];
    _.each(options, function (k, v) {
      optionNodes.push(
        <option key={name + '-option-'.concat(k)} value={k}>
          {v}
        </option>,
      );
    });

    attributes = _.defaults(attributes, {
      name: name,
      className: 'form-control',
      ref: name + 'Input',
      value: this.state[name],
      onChange: this.getSelectInputChangeHandler(name),
    });

    return React.createElement('select', attributes, optionNodes);
  },

  /**
   *
   * @param inputDef
   * @returns {XML}
   */
  getInputAndLabelNode: function (inputDef) {
    var labelNode = null;
    if (inputDef.label) {
      labelNode = <label>{inputDef.label}</label>;
    }
    return (
      <div key={inputDef.name + '-input-wrapper'}>
        {labelNode}
        {this.getInputNode(inputDef.name, inputDef.type || inputDef.attributes)}
      </div>
    );
  },

  getFormNode: function (inputDefinitions, submitButtonText) {
    var inputNodes = _.map(
      inputDefinitions,
      function (inputDef) {
        return this.getInputAndLabelNode(inputDef);
      }.bind(this),
    );

    return (
      <form onSubmit={this.handleSubmit}>
        {this.getErrorListNode()}
        {inputNodes}
        {this.getSubmitButtonNode(submitButtonText)}
      </form>
    );
  },

  getStateInput: function (name, attributes) {
    var defaults = {
      className: 'form-control',
      onChange: this.getSelectInputChangeHandler(name),
    };

    var props = _.extend(defaults, attributes || {});

    return (
      <select {...props} ref={name.concat('Input')} value={this.state[name]}>
        {this._getStateOptions(name)}
      </select>
    );
  },

  _getStateOptions: function (name) {
    var states = {
      Alabama: 'AL',
      Alaska: 'AK',
      Arizona: 'AZ',
      Arkansas: 'AR',
      California: 'CA',
      Colorado: 'CO',
      Connecticut: 'CT',
      Delaware: 'DE',
      'District of Columbia': 'DC',
      Florida: 'FL',
      Georgia: 'GA',
      Hawaii: 'HI',
      Idaho: 'ID',
      Illinois: 'IL',
      Indiana: 'IN',
      Iowa: 'IA',
      Kansas: 'KS',
      Kentucky: 'KY',
      Louisiana: 'LA',
      Maine: 'ME',
      Montana: 'MT',
      Nebraska: 'NE',
      Nevada: 'NV',
      'New Hampshire': 'NH',
      'New Jersey': 'NJ',
      'New Mexico': 'NM',
      'New York': 'NY',
      'North Carolina': 'NC',
      'North Dakota': 'ND',
      Ohio: 'OH',
      Oklahoma: 'OK',
      Oregon: 'OR',
      Maryland: 'MD',
      Massachusetts: 'MA',
      Michigan: 'MI',
      Minnesota: 'MN',
      Mississippi: 'MS',
      Missouri: 'MO',
      Pennsylvania: 'PA',
      'Rhode Island': 'RI',
      'South Carolina': 'SC',
      'South Dakota': 'SD',
      Tennessee: 'TN',
      Texas: 'TX',
      Utah: 'UT',
      Vermont: 'VT',
      Virginia: 'VA',
      Washington: 'WA',
      'West Virginia': 'WV',
      Wisconsin: 'WI',
      Wyoming: 'WY',
    };

    var options = [];
    _.each(states, function (abr, state) {
      options.push(
        <option key={'state-option-'.concat(abr, '-', name)} value={abr}>
          {abr} - {state}
        </option>,
      );
    });

    return options;
  },

  getInputValue: function (name) {
    return this.refs[name + 'Input'].getDOMNode().value;
  },

  getSubmitButtonNode: function (text, classes) {
    classes = classes || 'btn btn-default btn-submit pull-right top-buffer-10';
    var disabled = '';
    if (this.state.submitted) disabled = 'disabled';
    return (
      <button type="submit" disabled={disabled} className={classes}>
        {text || 'Submit'}
      </button>
    );
  },

  getErrorListNode: function () {
    var errs = this.state.validationErrors || [];

    if (this.state.errors) errs = errs.concat(this.state.errors);

    if (!errs || !errs.length) {
      return null;
    }

    var liNodes = _.map(errs, function (err) {
      return <li key={'form-err-' + err}>{err}</li>;
    });

    return (
      <div className="alert alert-danger">
        <ul>{liNodes}</ul>
      </div>
    );
  },

  clearValidationErrors: function () {
    this.setState({
      validationErrors: [],
    });
  },

  handleSubmit: function (e) {
    e.preventDefault();

    this.clearValidationErrors();

    var validationErrors = this.getValidationErrors();

    if (validationErrors && validationErrors.length) {
      return this.setState({
        validationErrors: validationErrors,
      });
    }

    this.formDidValidate();
  },

  /**
   *  Validate an email
   *
   *  @param {String} email
   *  @return {Boolean}
   */
  validateEmail: function (email) {
    var emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    // make sure email is truthy
    // make sure email passes the regex

    return Boolean(email && !!emailRegex.test(email));
  },

  /**
   *  Validate an Phone Number
   *
   *  @param {String} num
   *  @return {Boolean}
   */

  validatePhoneNumber: function (num) {
    if (num && num.length >= 10 && validator.isNumeric(num)) return true;
    return false;
  },

  /**
   *  Validate an text field
   *
   *  @param {String} str
   *  @return {Boolean}
   */

  validateText: function (str) {
    return str ? true : false;
  },

  validatePassword: function (pass) {
    // make sure pass is truthy
    // make sure pass is at least 6 characters

    return Boolean(pass && pass.length >= 6);
  },

  /**
   *  Focus an input
   *
   *  @param {String} name
   *  @return {undefined}
   */
  focusInput: function (name) {
    ReactDOM.findDOMNode(this.refs[name + 'Input']).focus();
  },

  /**
   * ### focusFirstInput()
   *
   * Sets focus on the first field, when given a list of candidate field names
   *
   * @param {Array} fields list of fields that are candidates for focusing
   */
  focusFirstInput: function (fields) {
    if (fields && fields.length) {
      this.focusInput(fields[0]);
    }
  },

  validationFieldStyle(formState, fieldName) {
    var val = formState.get(fieldName);

    if (!val) return '';

    var isValid = this['validateField_' + fieldName](val);

    if (isValid) return 'success';

    return 'error';
  },

  updateField(stateKey, field, value, action) {
    var state = this.state[stateKey];

    var mutation = {};
    mutation[stateKey] = state.set(field, value);
    this.setState(mutation);

    action(field, value);
  },
};

export default FormMixin;
